// FormThree.js
import React from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import renderSelectField from "shared/components/form/Select";
import Input from "components/ReduxForm/Input";

const FormThree = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormThreeSubmit
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("certificate_emission");

	const loading = selector(state, "loading");
	const knowAbout = selector(state, "knowAbout");

	const handleNextClick = async event => {
		event.preventDefault();
		handleSubmit(onFormThreeSubmit);
	};

	const options = [
		{ value: "Folders/Cartaz", label: "Folders/Cartaz" },
		{
			value: "Portal da Escola na Internet",
			label: "Portal da Escola na Internet"
		},
		{ value: "Correio Eletrônico", label: "Correio Eletrônico" },
		{ value: "Rádio/TV", label: "Rádio/TV" },
		{ value: "Universidade", label: "Universidade" },
		{ value: "Amigos", label: "Amigos" },
		{ value: "Redes Sociais", label: "Redes Sociais" },
		{ value: "Entidades Parceiras", label: "Entidades Parceiras" },
		{ value: "Outros", label: "Outros" }
	];

	return (
		<div>
			<form className="form" onSubmit={handleNextClick}>
				<div className="form__form-group">
					<div className="flex-center">
						<h3 className="account__title">
							Como você tomou conhecimento deste evento?
						</h3>

						<br />
					</div>
					<br />
					<div
						className="form__form-group-field"
						// style={{ justifyContent: "space-around" }}
					>
						<Field
							name="knowAbout"
							component={renderSelectField}
							type="text"
							options={options}
							placeholder="Selecione uma opção"
							required
						/>
					</div>

					{knowAbout?.value === "Outros" && (
						<>
							<div className="form__form-group-field">
								<Field
									name="knowAboutOther"
									component={Input}
									type="text"
									placeholder="Ex.: Jornal"
								/>
							</div>
							<br />
						</>
					)}
				</div>

				{/* Campo oculto para enviar o status como 'ativo' */}
				{/* <Field name="status" component="input" type="hidden" value="ativo" /> */}

				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={previousPage}
					>
						Voltar
					</button>
					<button
						type="submit"
						className="btn btn-primary account__btn account__btn--small"
						disabled={pristine || submitting || loading}
					>
						{loading ? (
							<Spinner type="grow" size="sm" color="dark" />
						) : (
							"Próximo"
						)}
					</button>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: "certificate_emission",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 3)
})(FormThree);
